export default "__VITE_ASSET__CaHLC29p__"